export const OutlookCalendarHowItWorks: React.FC = () => {
  return (
    <div>
      <p>
        Connect your Outlook Calendar to give Zocks access to your meeting schedule. Once connected, Zocks automatically syncs your upcoming meetings and can
        join them without manual invitation.
      </p>
      <p>
        Your meetings appear in Zocks' Upcoming Meetings list, giving you visibility into what's ahead. This enables you to prepare for meetings in advance by
        reviewing your Meeting Prep.
      </p>
      <p>
        When a meeting starts, Zocks joins automatically. No need to remember to invite your AI Assistant - it's already there, ready to analyze your
        conversation.
      </p>
      <p>
        <b>Outlook Add-in</b>
      </p>
      <p>
        Install the Zocks Outlook add-in to access your AI Assistant directly within Outlook. The add-in brings client intelligence into your inbox and
        calendar, letting you view Meeting Prep, contact information without leaving Outlook. You can also generate smart email replies using your custom
        templates, manage tasks, and get instant answers from your Ask Anything AI. Search for "Zocks AI" in the Outlook Apps section to install it. Learn more
        about the Outlook Add-in <a href='https://help.zocks.io/en/articles/11963353-how-to-set-up-the-outlook-add-in-plugin'>here</a>.
      </p>
    </div>
  )
}
